import Vue from 'vue'

import VueRouter, { RouteConfig } from 'vue-router'

import Home from '../views/Home.vue'

import Login from '../views/Login.vue'

import Register from '../views/Register.vue'

import ForgotPassword from '../views/ForgotPassword.vue'

import Cart from "@/views/Cart.vue"

import ChangeLogs from '../views/ChangeLogs.vue'

import Dashboard from '../views/Dashboard.vue'

import Exceptions from '../views/Exceptions.vue'

import Financials from '../views/Financials.vue'

import Form from '../views/Form.vue'

import NotFound from '../views/NotFound.vue'

import ResetPassword from '../views/ResetPassword.vue'

import SendTestEmail from '../views/SendTestEmail.vue'

import VerifyEmail from '../views/VerifyEmail.vue'

import Orders from '../views/Orders.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',

        component: Home
    },
    {
        path: '/Login',

        component: Login
    },
    {
        path: '/Register',

        component: Register
    },
    {
        path: '/ForgotPassword',

        component: ForgotPassword
    },
    {

        path: '/Cart',

        component: Cart
    },
    {

        path: '/ChangeLogs',

        component: ChangeLogs
    },
    {
        path: '/Dashboard',

        component: Dashboard
    },
    {

        path: '/Exceptions',

        name: 'Exceptions',

        component: Exceptions

    },
    {

        path: '/Financials',

        name: 'Financials',

        component: Financials

    },
    {

        path: '/Form',

        name: 'Form',

        component: Form

    },
    {

        path: '/NotFound',

        name: 'NotFound',

        component: NotFound

    },
    {
        path: '/ResetPassword',

        name: 'ResetPassword',

        component: ResetPassword

    },
    {

        path: '/SendTestEmail',

        name: 'SendTestEmail',

        component: SendTestEmail

    },
    {

        path: '/VerifyEmail',

        name: 'VerifyEmail',

        component: VerifyEmail

    },
    {

        path: '/Orders',

        name: 'Orders',

        component: Orders

    },
]

const router = new VueRouter({

  mode: 'history',

  base: process.env.BASE_URL,

  routes

})

export default router
